import Component from './Component'

export default class GeoCoords extends Component {

	static _type = 'GeoCoords'

	form			// Parent form component

	input_els		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_els = this.base.querySelectorAll('input')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Register event handlers
		$(this.input_els).on('input', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		if ('init' in this.params && typeof this.params.init == 'function') {
			this.params.init(this)
		}
	}

	inputListener = () => {
		// Send data to the record
		var coords = [ $(this.input_els[0]).val(), $(this.input_els[1]).val() ]
		if (!coords[0] || !coords[1]) coords = null
		this.form.data[this.params.name] = coords
	}

	updateListener = (value, errors) => {

		// If the value changed, update it on the input as well
		if ($(this.input_els[0]).val() != (value ? value[0] : '')) {
			$(this.input_els[0]).val(value ? value[0] : '')
		}
		if ($(this.input_els[1]).val() != (value ? value[1] : '')) {
			$(this.input_els[1]).val(value ? value[1] : '')
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').removeClass('is-invalid')
			}
			$(this.input_els).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').addClass('is-invalid')
			}
			$(this.input_els).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_els).off('input', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.input_els
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
